<form [formGroup]="form" (ngSubmit)="save()">
<h1 mat-dialog-title>Turno en espera seguimiento</h1>
<div mat-dialog-content>

    <mat-form-field class="full-control">
        <mat-select formControlName="MedicalAppointmentWaitState" placeholder="Estado" required>
          <mat-option *ngFor="let medicalAppointmentWaitState of medicalAppointmentWaitStates" [value]="medicalAppointmentWaitState">
            {{medicalAppointmentWaitState.Name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="f.MedicalAppointmentWaitState.errors && f.MedicalAppointmentWaitState.errors.required">
          Seleccione un motivo
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-control">
        <textarea  formControlName="Observation" matInput placeholder="Observaciones"></textarea>
      </mat-form-field>
  
      <mat-divider></mat-divider>
     <div class="observation-table-scroll">
      <mat-spinner *ngIf="loading"></mat-spinner>
      <table *ngIf="!loading" class="table-content">
        <tr>
          <th class="cell-user">Fecha</th>
          <th class="cell-user">Estado</th>
          <th class="cell-user">Usuario</th> 
          <th>Observaciones</th>
        </tr>

        <tr *ngFor="let medicalAppointmentWaitTrace of medicalAppointmentWaitTraces">
          <td class="cell-user">{{medicalAppointmentWaitTrace.Date | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td class="cell-user">{{medicalAppointmentWaitTrace.StateName}}</td>
          <td class="cell-user">{{medicalAppointmentWaitTrace.UserFullName}}</td>
          <td><div style="width:100%; max-width:400px; word-wrap: break-word">{{medicalAppointmentWaitTrace.Observation}} </div></td>
        </tr>
      </table>
    </div>
  </div>
  <div class="clearfix">
      <div class="pull-right">
        <mat-spinner [diameter]="20" *ngIf="loadingAction"></mat-spinner>
        <button *ngIf="!loadingAction" mat-button type="submit">Guardar</button>
        <button *ngIf="!loadingAction" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
      </div>
    </div>
  </form>